<template>
  <div
    v-if="active"
    v-scroll-lock="true"
    class="modal active"
  >
    <div class="modal-overlay"></div>

    <section class="modal-container appointment-simple agenda-online-controls">
      <header class="modal-header appointment-simple__header">
        <a
          class="btn btn-clear float-right appointment-simple__close"
          aria-label="close"
          @click="close"
        />

        <h1 class="agenda-online-controls__title text-blue">
          Consultório Virtual
        </h1>
      </header>

      <article class="modal-body appointment-simple__body">
        <p class="agenda-online-controls__text">
          Seus pacientes podem visualizar seus horários disponíveis, agendar e pagar online.
          Você recebe uma notificação com os dados do agendamento.
        </p>

        <p class="agenda-online-controls__text">
          Mande seu link por WhatsApp ou e-mail, coloque no seu perfil nas redes sociais.
          Ofereça esse diferencial aos seus pacientes!
        </p>

        <div class="agenda-online-controls__controls">
          <textarea
            v-model="url"
            readonly
            class="agenda-online-controls__input"
            onclick="this.focus();this.select()"
          />

          <div
            id="control-agenda-online"
            class="agenda-online-controls__button"
            @mouseenter="ui.showVisitLink = true"
            @mouseleave="ui.showVisitLink = false"
            @click="openLink"
          >
            <dr-icon
              color="rgb(86, 189, 210)"
              name="visitLink"
              class="agenda-online-controls__icon"
            />

            <transition name="fade">
              <div
                v-if="ui.showVisitLink"
                class="agenda-online-controls__tooltip"
              >
                Visitar meu consultório virtual
              </div>
            </transition>
          </div>

          <div
            id="control-copy"
            class="agenda-online-controls__button"
            @mouseenter="ui.showCopy = true"
            @mouseleave="ui.showCopy = false"
            @click="copyText(url)"
          >
            <dr-icon
              color="rgb(86, 189, 210)"
              name="copy"
              class="agenda-online-controls__icon"
            />

            <transition name="fade">
              <div
                v-if="ui.showCopy"
                class="agenda-online-controls__tooltip"
              >
                {{ ui.copyText }}
              </div>
            </transition>
          </div>

          <div
            id="control-whatsapp"
            class="agenda-online-controls__button"
            @mouseenter="ui.showWhatsapp = true"
            @mouseleave="ui.showWhatsapp = false"
            @click="shareUrl"
          >
            <dr-icon
              color="rgb(86, 189, 210)"
              name="whatsapp"
              class="agenda-online-controls__icon"
            />

            <transition name="fade">
              <div
                v-if="ui.showWhatsapp"
                class="agenda-online-controls__tooltip"
              >
                Compartilhar no WhatsApp
              </div>
            </transition>
          </div>
        </div>

        <p class="agenda-online-controls__text">
          Para incorporar seu perfil público em seu site, utilize o código abaixo.
        </p>

        <div
          class="agenda-online-controls__embed"
          @mouseenter="ui.showEmbeddableCode = true"
          @mouseleave="ui.showEmbeddableCode = false"
        >
          <textarea
            v-model="embeddableCode"
            readonly
            class="agenda-online-controls__input agenda-online-controls__input--full"
            onclick="this.focus();this.select()"
          />

          <transition name="fade">
            <div
              v-if="ui.showEmbeddableCode"
              class="agenda-online-controls__embed-button"
              @click="copyText(embeddableCode, 'embed')"
            >
              <dr-icon
                color="rgb(86, 189, 210)"
                name="copy"
                class="agenda-online-controls__embed-icon"
              />

              {{ ui.copyCode }}
            </div>
          </transition>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import EventBus from '@/globals/eventBus'

export default {
  name: 'DrAgendaOnlineControls',

  props: {
    active: {
      required: true,
      type: Boolean,
      default: () => false
    },

    doctor: {
      required: true,
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      ui: {
        showLink: false,
        showCopy: false,
        showWhatsapp: false,
        showVisitLink: false,
        showEmbeddableCode: false,
        copyText: 'Copiar link',
        copyCode: 'Copiar código'
      },
      observer: null
    }
  },

  watch: {
    'ui.showCopy': {
      deep: false,
      immediate: false,
      handler (v) {
        if (!v) {
          this.ui.copyText = 'Copiar link'
        }
      }
    },

    'ui.showEmbeddableCode': {
      deep: false,
      immediate: false,
      handler (v) {
        if (!v) {
          this.ui.copyCode = 'Copiar código'
        }
      }
    },

    active: {
      deep: false,
      immediate: true,
      handler (v) {
        if (this.observer) {
          this.observer.disconnect()
        }

        if (v) {
          this.createObserver()
        }
      }
    }
  },

  computed: {
    url () {
      return `${window.location.origin}/public/doctor/${this.doctor.uuid}`
    },

    embeddableCode () {
      return `<iframe frameborder="0" width="630" height="100%" src="${this.url}"></iframe>`
    },

    whatsappMessage () {
      return `Olá, veja o link para agendamento online: ${this.url}`
    }
  },

  methods: {
    close () {
      EventBus.$emit('close-agenda-online-controls')
    },

    copyText (what, control = 'link') {
      navigator.clipboard
        .writeText(what)
        .then(() => {
          if (control === 'link') {
            this.ui.copyText = 'Copiado!'
          } else {
            this.ui.copyCode = 'Código copiado!'
          }
        })
        .catch(() => {
          if (control === 'link') {
            this.ui.copyText = 'Erro :('
          } else {
            this.ui.copyCode = 'Erro :('
          }
        })
    },

    shareUrl () {
      window.open(`https://web.whatsapp.com/send?text=${this.whatsappMessage}`, '_blank')
    },

    openLink () {
      window.open(this.url, '_blank')
    },

    createObserver () {
      this.$nextTick(() => {
        const controlAgendaOnline = document.querySelector('#control-agenda-online')
        const controlCopy = document.querySelector('#control-copy')
        const controlWhatsapp = document.querySelector('#control-whatsapp')

        const config = { attributes: false, childList: true, subtree: true }

        this.observer = new MutationObserver(this.setTooltipPosition)

        this.observer.observe(controlAgendaOnline, config)
        this.observer.observe(controlCopy, config)
        this.observer.observe(controlWhatsapp, config)
      })
    },

    setTooltipPosition (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const tooltip = mutation.target.querySelector('.agenda-online-controls__tooltip') || null
          if (tooltip) {
            const { top, left } = mutation.target.getBoundingClientRect()
            const height = mutation.target.offsetHeight

            tooltip.style.top = `${top - height}px`
            tooltip.style.left = `${left}px`
          }
        }
      }
    }
  }
}
</script>
